export const environment = {
  production: true,
  name: 'staging',
  appDomain: 'culturequestion-test.fi',
  appKey: 'culturequestion',
  appUrl: 'https://culturequestion-test.fi',
  // apiUrl: 'https://cebt-test.fi',
};
// For instructions how to use environment files, see the comments in the environment.ts file.